import { createRoot } from 'react-dom/client';
import { lazy, Suspense } from 'react';
import './styles.css';
import './AnimatedNumber.css';
import './PointsAmount.css';
import './arena/ExploreScreen.css';
import './arena/CoinModal.css';
import './arena/CoinChart.css';
import './arena/BetBursts.css';
import './arena/MobileLayout.css';
import './arena/LiveArenaEmpty.css';
import SiteEntry from './SiteEntry';
declare const __TEAM_PREVIEW__: boolean;
declare const __GAME_PREVIEW__: boolean;
const isPreview =
  __GAME_PREVIEW__ ||
  __TEAM_PREVIEW__ ||
  new URLSearchParams(location.search).get('demo') === '1';
const Preview = lazy(() =>
  __GAME_PREVIEW__
    ? import('./game-preview/GamePreview')
    : __TEAM_PREVIEW__
      ? import('./demo/TeamPreviewArena')
      : import('./reflex/ReflexApp'),
);
createRoot(document.getElementById('root')!).render(
  <Suspense
    fallback={
      <div className="site-loading" role="status" aria-label="Loading" />
    }
  >
    {isPreview ? <Preview /> : <SiteEntry />}
  </Suspense>,
);
